// 明るめのゴールド：#edca58
// 明るめのシャンパンゴールド：#f7be02
export const atomsLabelColorObjs = [
  { value: 'none', outOfEdge: '#1F201F', edge: '#ccc', core: '#fff' },
  { value: 'ccc', outOfEdge: '#1F201F', edge: '#BEA75C', core: '#edca58' },
  { value: 'ddd', outOfEdge: '#1F201F', edge: '#BEA75C', core: '#f7be02' },
  { value: 'eee', outOfEdge: '#0a007d', edge: '#c42823', core: '#edca58' },
  { value: 'fff', outOfEdge: '#c42823', edge: '#0a007d', core: '#edca58' },
  { value: 'ggg', outOfEdge: '#1F201F', edge: '#edca58', core: '#cbd0d3' },
  { value: 'hhh', outOfEdge: '#2c1bf2', edge: '#c42823', core: '#edca58' },
  { value: 'iii', outOfEdge: '#1F201F', edge: '#edca58', core: '#55B0BE' },
  { value: 'jjj', outOfEdge: '#1F201F', edge: '#926945', core: '#edca58' },
  { value: 'kkk', outOfEdge: '#1F201F', edge: '#1F201F', core: '#4f4f4f' },
  { value: 'lll', outOfEdge: '#1F201F', edge: '#836242', core: '#f7be02' },
  { value: 'mmm', outOfEdge: '#1F201F', edge: '#adadad', core: '#adadad' },
  { value: 'nnn', outOfEdge: '#1F201F', edge: '#1F201F', core: '#4f4f4f' },
  { value: 'ooo', outOfEdge: '#1F201F', edge: '#1D2477', core: '#3CBEEF' },
  { value: 'ppp', outOfEdge: '#1F201F', edge: '#4B1855', core: '#B76EE1' },
  { value: 'qqq', outOfEdge: '#1F201F', edge: '#8F1528', core: '#F9678D' },
  { value: 'rrr', outOfEdge: '#1F201F', edge: '#009B7A', core: '#35F3C7' },
  { value: 'uuu', outOfEdge: '#1F201F', edge: '#edca58', core: '#ff1aaf' },
  { value: 'yyy', outOfEdge: '#1F201F', edge: '#f7be02', core: '#f7be02' },
  { value: 'zzz', outOfEdge: '#1F201F', edge: '#cbd0d3', core: '#cbd0d3' }
]
